module.exports = __webpack_public_path__ + "media/images/logo-anab-6f5ade5478e74d4bc022350187b4c690.png";